import { useState } from 'react';
import { ContactForm } from '@/components/LazyContactForm';
import { useMetaPixel } from '@/hooks/useMetaPixel';

const Footer = () => {
  const [showContactForm, setShowContactForm] = useState(false);
  const { trackEvent } = useMetaPixel();

  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Track WhatsApp button click
    trackEvent('InitiateContact', {
      source: 'whatsapp_button',
      content_name: 'WhatsApp Contact Button'
    });
    
    setShowContactForm(true);
  };

  const handleFormClose = () => {
    setShowContactForm(false);
  };
  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 border-t border-border/50 relative">
      {/* WhatsApp Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1eb855] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        aria-label="Falar no WhatsApp"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.051 3.488"/>
        </svg>
      </button>
      
      {/* Contact Form Modal */}
      <ContactForm 
        isOpen={showContactForm} 
        onClose={handleFormClose}
      />
      
      
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="flex items-center justify-center w-10 h-10 bg-gradient-hero rounded-lg">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span className="text-xl font-bold text-foreground">Scale IA</span>
            </div>
            <p className="text-muted-foreground max-w-md mb-6">
              A IA que aumenta seu faturamento com consistência. 
              Responde, qualifica e agenda leads automaticamente, 24/7.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Produto</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">Como funciona</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">Demonstração</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">Resultados</a></li>
              
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Suporte</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">FAQ</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">Contato</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-border/50">
          <div className="text-muted-foreground text-sm">
            <p>© 2024 Scale IA. Todos os direitos reservados.</p>
            <p>CNPJ: 61.837.876/0001-81</p>
          </div>
          <div className="flex items-center gap-6 mt-4 md:mt-0">
            <a href="/politica-de-privacidade" className="text-muted-foreground hover:text-foreground text-sm transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">
              Privacidade
            </a>
            <a href="/termos-de-servicos" className="text-muted-foreground hover:text-foreground text-sm transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">
              Termos
            </a>
            <a href="/cookies" className="text-muted-foreground hover:text-foreground text-sm transition-smooth py-1 px-1 min-h-[24px] min-w-[24px] inline-flex items-center">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;